export default "__VITE_ASSET__Xr42zMgF__"